<script setup>
import { ref, watch } from "vue";
import TextInput from "@/components/TextInput.vue";
import Icon from "@/components/Icon.vue";
import ModalShow from "@/components/ModalShow.vue";
import { useConfigStore } from '@/stores/useConfigStore.js'
import BaseComponent from "@/components/BaseComponent.vue";
import ModalRadio from "@/components/ModalRadio.vue";
import SearchSelectComponent from "@/components/SearchSelectComponent.vue";
import api, { customApi, baseURL} from "@/libs/api.js";
import EventBus from "@/libs/eventBus";
const useConfig = useConfigStore();

const props = defineProps({
    show: {
        type: Boolean,
        default: false
    }
});

const form = ref({});
const errors = ref({});
const loading = ref(false);
const isBase = ref(false);
const isModal = ref(false);
const dataCity = ref([]);
const showCity = ref(false);
const dataDistrict = ref([]);
const dataGender = ref([]);
const user = ref({})

const emits = defineEmits(["callApi", "callBack"]);
watch(
    () => useConfig.user,
    (newUser) => {
        if (newUser && Object.keys(newUser).length > 0) {
            user.value = newUser
        }
    },
    { immediate: true, deep: true }
)
watch(() => props.show, (newShow) => {
    if (newShow) {
        getCity();
        getData();
    }
});
watch(() => form.value.city_id, (newValue, oldValue) => {
    if (newValue && dataCity.value.length > 0) {
        dataDistrict.value = dataCity.value.find(item => item.id === form.value.city_id).descendants;
    }
});

const getData = async () => {
    await api.get('app/user-edit').then((response) => {
        const data = response.data;
        // form.value = { ...data };
        dataGender.value = data.dataGender;
        form.value.gender = data.information?.gender || 3;
        let birthday = '';
        if(data.information && data.information.birthday){
            birthday = new Date(data.information.birthday).toISOString().split("T")[0];
        }
        
        form.value.name = data.name
        form.value.phone = data.phone
        form.value.email = data.email 
        form.value.address = data.address
        form.value.birthday = birthday
        form.value.idNumber = data.information?.idNumber || '';
        form.value.idNumberBackImage = data.information?.idNumberBackImage || '';
        form.value.idNumberFrontImage = data.information?.idNumberFrontImage || '';
        let date = '';
          if(data.information && data.information.date){
            date = new Date(data.information.date).toISOString().split("T")[0];
        }
        form.value.date = date
        form.value.place = data.information?.place || '';
        form.value.job = data.information?.job || '';
        form.value.workplace = data.information?.workplace || '';
        form.value.contactPersonName = data.information?.contactPersonName || '';
        form.value.contactPersonPhone = data.information?.contactPersonPhone || '';
        form.value.consultantName = data.information?.consultantName || '';
        form.value.consultantPhone = data.information?.consultantPhone || '';
        form.value.city_id = data.city_id ?? 0;
        form.value.district_id = data.district_id ?? 0;
    });
}

const getCity = async () => {
    await api.get('app/city-list').then((response) => {
        dataCity.value = response.data.data
        
    })
}

const submit = () => {
    showLoading();
    let formData = new FormData();
    for (const key in form.value) {
        if (Object.prototype.hasOwnProperty.call(form.value, key)) {
            // Nếu là file ảnh thì xử lý riêng
            if (key === "picture") {
                formData.append(key, form.value[key]); // Thêm file ảnh
            } else {
                formData.append(key, form.value[key]); // Thêm các giá trị khác
            }
        }
    }
    customApi({
        method: 'POST',
        url: 'app/user-update',
        data: formData,
        headers: {
            'Content-Type': 'multipart/form-data'
        },
    }).then((res) => {
             useConfig.setUser(res.user);
            EventBus.emit('show-notification', JSON.stringify({
                    id: '',
                    title: "Thông báo!",
                    message: `Cập nhật thông tin thành công.`,
                    url: '',
                    type: 'success',
                    showtime: 2000
                }));
            showLoading();
        }).catch((err) => {
            if (err?.response?.status === 422) {
                errors.value = err.response.data.errors;
            }
            showLoading();
        });
};

const close = () => {
    form.value = {};
    emits("callBack", false);
};

const showLoading = () => {
    loading.value = !loading.value;
};

const showModal = () => {
    isBase.value = true;
    isModal.value = true;
};

const updateGender = (e) => {
    form.value.gender = e.id;
}

const handleCallBack = () => {
    isBase.value = false;
    isModal.value = false;
    showCity.value = false;
};
const imagePreview = ref('');
const handleFileUpload = (files) => {
    const file = files.target.files[0];
    if (file) {
        form.value.picture = file
        imagePreview.value = URL.createObjectURL(file); // Tạo URL xem trước ảnh
    }
};
const hanldeCity = (e) => {
    dataDistrict.value = e.descendants
    if (e) {
        form.value.country_id = null
    }
};
</script>
<template>
    <ModalShow :show="show" title="Chỉnh sửa thông tin" @call-back="close">
        <template #headerRight>
            <Icon name="qr-code" class="w-6 h-6 fill-white" />
        </template>
        <div class="w-full flex justify-start items-start pt-4 px-6">
            <div
                class="w-20 h-20 object-contain rounded-full relative flex justify-center items-center border border-white">
                <div
                    class="absolute w-6 h-6 bottom-0 right-0 bg-slate-400 border border-white rounded-full overflow-hidden">
                    <label for="file" class="flex justify-center items-center h-full w-full">
                        <svg class="w-4 h-4 fill-white" xmlns="http://www.w3.org/2000/svg" height="512"
                            viewBox="0 0 32 32" width="512">
                            <g id="Layer_2" data-name="Layer 2">
                                <circle cx="16" cy="17" r="5" />
                                <path
                                    d="m27 8h-2.764a.994.994 0 0 1 -.894-.553l-.895-1.789a2.983 2.983 0 0 0 -2.683-1.658h-7.528a2.983 2.983 0 0 0 -2.683 1.658l-.9 1.789a.994.994 0 0 1 -.889.553h-2.764a3 3 0 0 0 -3 3v14a3 3 0 0 0 3 3h22a3 3 0 0 0 3-3v-14a3 3 0 0 0 -3-3zm-11 16a7 7 0 1 1 7-7 7.008 7.008 0 0 1 -7 7zm10-11a1 1 0 1 1 1-1 1 1 0 0 1 -1 1z" />
                            </g>
                        </svg>
                        <input type="file" class="hidden" id="file" ref="fileInput" @change="handleFileUpload"
                            accept="image/*">
                    </label>
                </div>
                <div v-if="imagePreview" class="w-full h-full bg-white rounded-full overflow-hidden">
                    <img :src="imagePreview" alt="avatar" class="object-cover h-full w-full">
                </div>
                <div v-else-if="user?.picture != []" class="w-full h-full bg-white rounded-full overflow-hidden">
                    <img :src="baseURL + user?.pictures[0]?.fullsize" alt="avatar" class="object-cover h-full w-full">
                </div>
                <div v-else
                    class="w-full h-full flex justify-center items-center bg-amber-600 rounded-full overflow-hidden">
                    <svg class="w-10 h-10 fill-white" xmlns="http://www.w3.org/2000/svg" viewBox="-42 0 512 512.002">
                        <path
                            d="m210.351562 246.632812c33.882813 0 63.222657-12.152343 87.195313-36.128906 23.972656-23.972656 36.125-53.304687 36.125-87.191406 0-33.875-12.152344-63.210938-36.128906-87.191406-23.976563-23.96875-53.3125-36.121094-87.191407-36.121094-33.886718 0-63.21875 12.152344-87.191406 36.125s-36.128906 53.308594-36.128906 87.1875c0 33.886719 12.15625 63.222656 36.132812 87.195312 23.976563 23.96875 53.3125 36.125 87.1875 36.125zm0 0" />
                        <path
                            d="m426.128906 393.703125c-.691406-9.976563-2.089844-20.859375-4.148437-32.351563-2.078125-11.578124-4.753907-22.523437-7.957031-32.527343-3.308594-10.339844-7.808594-20.550781-13.371094-30.335938-5.773438-10.15625-12.554688-19-20.164063-26.277343-7.957031-7.613282-17.699219-13.734376-28.964843-18.199219-11.226563-4.441407-23.667969-6.691407-36.976563-6.691407-5.226563 0-10.28125 2.144532-20.042969 8.5-6.007812 3.917969-13.035156 8.449219-20.878906 13.460938-6.707031 4.273438-15.792969 8.277344-27.015625 11.902344-10.949219 3.542968-22.066406 5.339844-33.039063 5.339844-10.972656 0-22.085937-1.796876-33.046874-5.339844-11.210938-3.621094-20.296876-7.625-26.996094-11.898438-7.769532-4.964844-14.800782-9.496094-20.898438-13.46875-9.75-6.355468-14.808594-8.5-20.035156-8.5-13.3125 0-25.75 2.253906-36.972656 6.699219-11.257813 4.457031-21.003906 10.578125-28.96875 18.199219-7.605469 7.28125-14.390625 16.121094-20.15625 26.273437-5.558594 9.785157-10.058594 19.992188-13.371094 30.339844-3.199219 10.003906-5.875 20.945313-7.953125 32.523437-2.058594 11.476563-3.457031 22.363282-4.148437 32.363282-.679688 9.796875-1.023438 19.964844-1.023438 30.234375 0 26.726562 8.496094 48.363281 25.25 64.320312 16.546875 15.746094 38.441406 23.734375 65.066406 23.734375h246.53125c26.625 0 48.511719-7.984375 65.0625-23.734375 16.757813-15.945312 25.253906-37.585937 25.253906-64.324219-.003906-10.316406-.351562-20.492187-1.035156-30.242187zm0 0" />
                    </svg>
                </div>
            </div>
        </div>
        <div class="w-full pt-4 px-6">
            <TextInput label="Họ và tên" type="text" id="name" v-model="form.name" :errors="errors.name" />
        </div>
        <div class="w-full pt-4 px-6">
            <TextInput label="Số điện thoại" type="text" id="phone" v-model="form.phone" :errors="errors.phone" />
        </div>
        <div class="w-full pt-4 px-6">
            <TextInput label="Email" type="text" id="email" v-model="form.email" :errors="errors.email" />
        </div>
        <div class="w-full pt-4 px-6">
            <label for="gender" class="font-semibold">
                Giới tính
            </label>
            <div @click="showModal"
                class="w-full mt-1 relative flex justify-between items-center border border-gray-300 rounded-md px-4 py-3 focus:border-main focus:ring-main">
                <div class="w-full">
                    <span v-if="form.gender == 1">Nam</span>
                    <span v-else-if="form.gender == 2">Nữ</span>
                    <span v-else>Khác</span>
                </div>
                <div class="w-max h-auto ">
                    <Icon name="down" class="w-4 h-4 fill-gray-800" />
                </div>
            </div>
            <p v-if="errors && errors.gender" class="text-red-600 text-sm mt-1 px-4">
                {{ errors.gender }}
            </p>
        </div>
        <div class="w-full pt-4 px-6">
            <TextInput label="Ngày sinh" type="date" id="birthday" v-model="form.birthday" :errors="errors.birthday" />
        </div>
        <div class="w-full pt-4 px-6">
            <TextInput label="CMND/CCCD" type="text" id="idNumber" v-model="form.idNumber" :errors="errors.idNumber" />
        </div>
        <div class="w-full pt-4 px-6">
            <TextInput label="Ngày cấp" type="date" id="date" v-model="form.date" :errors="errors.date" />
        </div>
        <div class="w-full pt-4 px-6">
            <TextInput label="Nơi cấp CMND/CCCD" type="text" id="place" v-model="form.place" :errors="errors.place" />
        </div>
        <div class="relative w-full pt-4 px-6">
            <label for="city_id" class="font-semibold">
                Tỉnh/Thành phố
                <span class="text-red-600">*</span>
            </label>
            <SearchSelectComponent :data="dataCity" placeholder="Tỉnh/thành phố" class="mt-2" v-model:id="form.city_id" @return-data="hanldeCity"></SearchSelectComponent>
            <p v-if="errors && errors.city_id" class="text-red-600 text-sm mt-1 px-4">
                {{ errors.city_id }}
            </p>
        </div>
        <div class="w-full pt-4 px-6">
            <!-- <SearchSelectComponent></SearchSelectComponent>
            <label for="district_id" class="font-semibold">
                Quận/Huyện
                <span class="text-red-600">*</span>
            </label>
            <SearchSelectComponent :data="dataDistrict" placeholder="Quận/Huyện" v-model:id="form.district_id"
                @return-data="hanldeCity">
            </SearchSelectComponent>
            <p v-if="errors && errors.district_id" class="text-red-600 text-sm mt-1 px-4">
                {{ errors.district_id }}
            </p> -->
        </div>
        <div class="w-full pt-4 px-6">
            <TextInput label="Địa chỉ chi tiết" type="text" id="address" v-model="form.address"
                :errors="errors.address" />
        </div>
        <div class="w-full pt-12 pb-8 flex justify-center items-center px-6">
            <button v-if="loading === false" @click="submit" type="button"
                class="w-full font-bold text-center py-4 bg-main text-white rounded shadow"
                :class="{ 'animation_width': loading === true }">
                Cập nhật
            </button>
            <div v-else class="w-16 h-16 bg-main text-white rounded-full flex justify-center items-center">
                <svg class="w-14 h-14 fill-white animate-spin" xmlns="http://www.w3.org/2000/svg" fill="none"
                    height="512" viewBox="0 0 24 24" width="512">
                    <path
                        d="m12 22c-5.51 0-10-4.49-10-10 0-1.87.52-3.69 1.5-5.27.29-.47.91-.61 1.38-.32s.61.90999.32 1.37999c-.78 1.26-1.2 2.72001-1.2 4.21001 0 4.41 3.59 8 8 8s8-3.59 8-8-3.59-8-8-8c-.55 0-1-.45-1-1s.45-1 1-1c5.51 0 10 4.49 10 10s-4.49 10-10 10z" />
                </svg>
            </div>
        </div>
    </ModalShow>
    <BaseComponent v-model:show="isBase" @call-back="handleCallBack">
        <ModalRadio :show="isModal" title="Chọn giới tính" :data="dataGender" @call-api="updateGender"
            @call-back="handleCallBack" />
    </BaseComponent>
</template>
<style scoped>
.animation_width {
    animation: width 150ms linear;
}

@keyframes width {
    0% {
        width: 100%;
        opacity: 1;
    }

    100% {
        width: 0px;
        opacity: 0;
    }
}
</style>
